import { apiUrl, appId } from '../../config';
import EventEmitter, { IFunction } from '../event-emitter';
import { eventEmitter, EventKey } from '../../eventEmitter';
import modal from '../modal/index';

interface Data {
    [key: string]: any;
}
/**
 * 参数
 *
 * @interface IInterceptor
 */
export interface IRequestOption {

    /**
     * 请求内容
     *
     * @type {string}
     * @memberof IRequestOption
     */
    body?: string

    /**
     * 报头
     *
     * @type {Data}
     * @memberof IRequestOption
     */
    headers?: Data

    /**
     * 请求类型
     *
     * @type {'DELETE'}
     * @memberof IRequestOption
     */
    method?: 'DELETE' | 'GET' | 'POST' | 'PUT'

    /**
     * 启动错误弹窗
     *
     * @type {boolean}
     * @memberof IFetchOption
     */
    showFailToast?: boolean;

    /**
     * 是否捕获错误 [接口status错误,阻止代码的继续运行]
     *
     * @type {boolean}
     * @memberof IFetchOption
     */
    isCatchFail?: boolean;

    /**
     * 不自动获取授权
     *
     * @type {boolean}
     * @memberof IRequestOption
     */
    unAuthorization?: boolean

}

export enum RequestEventEnum {
    /**
     * 即将发送
     */
    WillSend,
    Receive
}

export interface RequestEventList extends IFunction {
    [RequestEventEnum.WillSend]: (params: IRequestOption) => void;
    [RequestEventEnum.Receive]: (res: Response) => void;
}


let lockPromise: Promise<void>;
class APPRequest {
    eventEmitter = new EventEmitter<RequestEventList>();

    defaultOptions: IRequestOption = {
        showFailToast: true,
        isCatchFail: true
    };
    props: any;

    async request<T>(url: string, data: Data | string = {}, options: IRequestOption): Promise<Response & { data: T }> {
        // if (!options.unAuthorization) {
        //     await authorization();
        // }

        let requestUrl = this.normalizationUrl(url);
        const requestOptions = { ...this.defaultOptions, ...options };
        let parameters = this.getParameters(options.method as string, data);
        requestUrl += parameters.url;
        const headers = await this.getHeaders();
        const params: IRequestOption = {
            ...requestOptions,
            headers
        };

        if (parameters.body) {
            params.body = parameters.body;
        }

        await this.eventEmitter.emit(RequestEventEnum.WillSend, params);
        let res: Response = null as any;

        try {
            res = await fetch(requestUrl, params);
        } catch (error) {
            res = {
                statusCode: -1,
                data: {}
            } as any;
        }

        await this.eventEmitter.emit(RequestEventEnum.Receive, res);

        if (requestOptions.showFailToast) {
            this.failToast(res, requestUrl);
        }

        if (requestOptions.isCatchFail) {
            await this.catchFail(res);
        }

        let returnData = await this.getData(res);
        return Object.assign(res, { data: returnData }) as any;
    }

    /**
     * 获取参数
     *
     * @private
     * @param {string} method
     * @param {Data} data
     * @returns
     * @memberof APPfetch
     */
    private getParameters(method: string, data: Data | string) {
        let url = '';
        let body = '';
        if (data && (method === 'GET' || method === 'DELETE')) {
            url += '?' + new URLSearchParams(data).toString();
        } else {
            if (data !== undefined) {
                if (typeof data === 'string') {
                    body = '"' + (data as any) + '"';
                } else {
                    body = JSON.stringify(data);
                }
            }
        }
        return {
            url,
            body
        };

    }

    /**
     * 获取response 返回值
     *
     * @private
     * @param {Response} response
     * @returns {(Promise<string | Data>)}
     * @memberof ZDfetch
     */
    private async getData<T>(response: Response): Promise<T> {
        response = response.clone();
        let responseText = await response.text();
        let data: any = {};
        try {
            if (responseText.indexOf('"') === 0 || responseText.indexOf('{') === 0 || responseText.indexOf('[') === 0) {
                data = JSON.parse(responseText);
            } else {
                data = responseText;
            }
        } catch (er) {
            data = 'JSON parse 失败';
        }
        return data;
    }

    private async getHeaders() {
        const headers: any = {};
        headers['Content-Type'] = 'application/json';
        const token = await localStorage.getItem('token');
        if (token) {
            (headers as any).Authorization = token;
        }

        return headers;
    }

    private normalizationUrl(url: string) {
        let requestUrl = url;

        if (typeof requestUrl === 'string') {
            if (apiUrl[apiUrl.length - 1] === '/') {
                if (requestUrl[0] === '/') {
                    requestUrl = requestUrl.replace('/', '');
                }
            } else {
                if (requestUrl[0] !== '/') {
                    requestUrl = '/' + requestUrl;
                }
            }

            if (!/^https{0,1}:\/\//g.test(requestUrl)) {
                requestUrl = `${apiUrl}${requestUrl}`;
            }
        }

        return requestUrl;
    }

    private async failToast(response: Response, url: string) {
        if (response.status === -1) {
            modal.toast('请求错误');
            return;
        }

        response = response.clone();
        if (response.status === 401) {
            eventEmitter.emit(EventKey.noAccess);
        }
        let responseText = await response.text();
        if (!this.validateStatus(response, responseText)) {
            let data = JSON.parse(responseText);
            if (data.code) {
                this.handleCode(data);
            } else if (response.status && response.status > 0) {
                modal.toast(`url:${url.toString()},statusCode:${response.status}`);
            } else if (response.status && response.status === -1) {
                modal.toast('网络请求失败，请检查您的网络。');
            } else {
                modal.toast('未知错误，万分抱歉！');
            }
        }
    }

    private handleCode(data: any) {
        switch (data.code) {
            case 418:
                modal.toast(`${data.description}`);
                break;
            case 401:
                localStorage.setItem('token', '');
                window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appId
                    + '&redirect_uri=' + window.location.href + '&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect'
                break
        }
    }


    private catchFail(response: Response) {
        response = response.clone();
        return new Promise<Response>(async (resolve, reject) => {
            let responseText = await response.text();
            if (this.validateStatus(response, responseText)) {
                resolve(response);
            } else {
                reject(response);
            }
        });
    }

    private validateStatus(response: Response, responseText?: string) {
        if (responseText) {
            const json = JSON.parse(responseText);
            if (json.code === 418) {
                return false;
            }
        }

        return response.status >= 200 && response.status < 300;
    }
}

const appFetch = new APPRequest();


export async function authorization() {
    if (lockPromise) {
        await lockPromise;
        return;
    }
    const search = new URLSearchParams(window.location.search);
    const code = search.get('code');


    if (code && !localStorage.getItem('token')) {
        lockPromise = new Promise(async resolve => {
            const { data } = await get('/wechat/wx_code/wx-token', {
                code: code
            }, {
                unAuthorization: true
            });
            localStorage.setItem('token', data.token);

            resolve();
            lockPromise = undefined as any;
        });
        return await lockPromise;
    }
}


export function get<T = any>(url: string, data?: Data | string, option: IRequestOption = {}) {
    return appFetch.request<T>(url, data, {
        method: 'GET',
        ...option
    });
}

export function post<T = any>(url: string, data?: Data | string, option: IRequestOption = {}) {
    return appFetch.request<T>(url, data, {
        method: 'POST',
        ...option
    });
}

export function put<T = any>(url: string, data?: Data | string, option: IRequestOption = {}) {
    return appFetch.request<T>(url, data, {
        method: 'PUT',
        ...option
    });
}

export function del<T = any>(url: string, data?: Data | string, option: IRequestOption = {}) {
    return appFetch.request<T>(url, data, {
        method: 'DELETE',
        ...option
    });
}

export default appFetch;
